<div class="tags-input-wrapper">
  <label *ngIf="label" class="tags-input-label">
    {{ label }}
    <span *ngIf="required" class="text-danger">*</span>
  </label>

  <div
    class="bootstrap-tagsinput"
    [class.focus]="focused"
    [class.disabled]="disabled"
    (click)="onContainerClick()"
  >
    <span
      *ngFor="let tag of tags; let i = index"
      class="tag label label-info"
      [style.background-color]="suggestionFor(tag)?.backgroundColour"
      [style.color]="suggestionFor(tag)?.fontColour"
    >
      {{ tag }}
      <span
        *ngIf="!disabled"
        class="tag-remove"
        (click)="removeTag(i)"
        role="button"
        tabindex="0"
        [style.color]="suggestionFor(tag)?.fontColour"
      >
        ×
      </span>
    </span>

    <app-input-text
      [bare]="true"
      [plain]="true"
      cssClass="tags-input-field"
      [placeholder]="tags.length === 0 ? placeholder : ''"
      [isDisabled]="disabled"
      [value]="inputValue"
      autocomplete="off"
      (inputEvent)="onInputChange($event)"
      (keydownEvent)="onInputKeyDown($event)"
      (blurEvent)="onInputBlur($any($event))"
      (focusEvent)="onInputFocus()"
    ></app-input-text>
  </div>

  <div class="tags-input-dropdown dropdown-menu show" *ngIf="dropdownOpen">
    <button
      *ngFor="let suggestion of filteredSuggestions; let i = index"
      type="button"
      class="dropdown-item"
      [class.active]="i === highlightedIndex"
      data-testid="tags-input-suggestion"
      (mousedown)="onSuggestionMouseDown($event, suggestion)"
    >
      <span
        class="tag"
        [style.background-color]="suggestion.backgroundColour"
        [style.color]="suggestion.fontColour"
        >{{ suggestion.label }}</span
      >
      <span
        *ngIf="suggestion.count != null"
        class="ml-auto font-size-secondary text-muted"
        data-testid="tags-input-count"
        >{{ suggestion.count }}
        <ng-container *ngIf="countLabelKey">{{
          countLabelKey | translate
        }}</ng-container></span
      >
    </button>
    <button
      *ngIf="showCreateOption"
      type="button"
      class="dropdown-item active"
      data-testid="tags-input-create"
      (mousedown)="onCreateMouseDown($event)"
    >
      <app-icon icon="fas fa-plus"></app-icon>
      {{ createOptionKey | translate: { label: inputValue.trim() } }}
    </button>
  </div>

  <div class="tags-input-hint" *ngIf="!disabled && !hideHint">
    <small class="text-muted">
      {{ 'admin.store.events.musicStyleHint' | translate }} {{ tags.length }}/{{
        maxTags
      }}
      tags
    </small>
  </div>
</div>
